<img
  src="../../../../assets/images/buildYourOwnTeamStore.png"
  class="headerImage"
/>
<div class="main-wrapper">
  <div class="header-label-margin common-margin center-align">
    <h5 class="blue-font-color">
      Design and sell custom sportwear on our easy-to-use online apparel
      platform.We manage your team store for you while you get back to what
      matters most-coaching the team!
    </h5>
  </div>
  <div class="btn-holder center-align">
    <button class="btn btn-primary btn-style">BUY FROM A LIVE STORE</button
    ><br />
    <button class="btn btn-primary btn-style">REQUEST FROM LIVE STORE</button
    ><br />
    <button class="btn btn-primary btn-style">BUILD YOUR OWN STORE</button
    ><br />
    <button class="btn btn-primary btn-style">STORE TEMPLATES</button>
  </div>
  <div class="list-label-margin common-margin margin-top-50">
    <h3 class="bold-font list-header">ADDITIONAL INFO</h3>
    <ul>
      <li class="custom-bulletin">PRICING</li>
      <li class="custom-bulletin">MINIMUMS</li>
      <li class="custom-bulletin">RECOMMENDATIONS FOR STORE BUILDING</li>
      <li class="custom-bulletin">ORDER TURN TIME</li>
      <li class="custom-bulletin">LATE ORDERS</li>
      <li class="custom-bulletin">FUNDRAISING</li>
      <li class="custom-bulletin">SPECIAL SORTING</li>
      <li class="custom-bulletin">REQUIRED ITEMS</li>
    </ul>
  </div>
</div>
